import { Injectable } from '@angular/core';
import { ApiLoadingService } from './api-loading.service';
import { ApiCallService } from './api-call.service';
import { Project, ProjectSearch } from './../models/index';
import { Router, Resolve, ActivatedRouteSnapshot, Params } from '@angular/router';

@Injectable()
export class ProjectService implements Resolve<Project[]> {
  constructor(
    private apiLoadingService: ApiLoadingService,
    private apiCallService: ApiCallService,
    private router: Router
  ) { }

  getProjects(projectSearch?: ProjectSearch, page?: number): Promise<Project[]> {
    let path = '/projects';

    if (projectSearch) {
      path += this.apiCallService.getSeachUrlParams(projectSearch, undefined, page);
    } else if (page) {
      path += '?page=' + page;
    }

    return this.apiCallService.get(path);
  }

  getProject(id: number): Promise<Project> {
    return this.apiCallService.get('/projects/' + id);
  }

  decodeUrlParams(params: Params): ProjectSearch {
    const projectSearch = new ProjectSearch();

    for (const field in params) {
      if (params.hasOwnProperty(field) && params[field] && params[field].length) {
        if (Array.isArray(projectSearch[field])) {
          if (Array.isArray(params[field])) {
            if (params[field].every((e, i, a) => isNaN(+e))) {
              projectSearch[field] = params[field];
            } else {
              projectSearch[field] = params[field].map(param => +param);
            }
          } else {
            if (+params[field]) {
              projectSearch[field] = [+params[field]];
            } else {
              projectSearch[field] = [params[field]];
            }
          }
        } else if (typeof projectSearch[field] === 'boolean') {
          projectSearch[field] = params[field] === 'true';
        } else if (!isNaN(params[field])) {
          projectSearch[field] = +params[field];
        } else {
          projectSearch[field] = params[field];
        }
      }
    }

    return projectSearch;
  }

  resolve(route: ActivatedRouteSnapshot): Promise<Project[]> {
    let id = route.params['id'] ? route.params['id'] : route.params['project_id'];
    const projectSearch = route.data['projectSearch'];

    if (id === undefined)
      id = route.data['project_id']

    let promise;

    if (id === undefined) {
      promise = projectSearch ? this.getProjects(projectSearch) : this.getProjects();

    } else {
      promise = this.getProject(id)
        .catch(error => {
          this.router.navigate(['/']);
          return false;
        });
    }

    this.apiLoadingService.startLoading(promise);

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/project.service.ts